export default "__VITE_ASSET__1eee32cb__"